import { CompositeNavigationProp, RouteProp } from "@react-navigation/native";
import {
  NativeStackNavigationProp,
  createNativeStackNavigator,
} from "@react-navigation/native-stack";
import { UserLoggedInNavigatorNavigationProp } from "../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";

type ProductDateTrackerStackRoutes = {
  ProductDateTrackerMain: object;
  ProductDateTrackerHistory: object;
};

export const ProductDateTrackerStack =
  createNativeStackNavigator<ProductDateTrackerStackRoutes>();

type ProductDateTrackerStackNavigationProp<
  T extends keyof ProductDateTrackerStackRoutes,
> = CompositeNavigationProp<
  UserLoggedInNavigatorNavigationProp<"ProductDateTracker">,
  NativeStackNavigationProp<ProductDateTrackerStackRoutes, T>
>;

type ProductDateTrackerStackRouteProp<
  T extends keyof ProductDateTrackerStackRoutes,
> = RouteProp<ProductDateTrackerStackRoutes, T>;
export type ProductDateTrackerStackScreenProps<
  T extends keyof ProductDateTrackerStackRoutes,
> = {
  navigation: ProductDateTrackerStackNavigationProp<T>;
  route: ProductDateTrackerStackRouteProp<T>;
};
